import styled from 'styled-components';
import {
  CardTitle,
  TitleAndAction,
  ButtonNew,
  ButtonReset,
  media,
  size,
  spacing,
} from 'ui';
import { Link } from 'react-router-dom';
import { MdAdd } from 'react-icons/md';
import { withTranslation } from 'react-i18next';

const MobileButton = styled(ButtonReset)`
  display: flex;
  font-size: ${size(1)};
  background-color: ${({ theme }) => theme.primary};
  color: #fff;
  border-radius: 100%;
  padding: ${spacing(0.125)};

  ${media.tablet`display:none;`};
`;

const DesktopButton = styled(ButtonNew)`
  display: none;

  ${media.tablet`display:flex;`};
`;

const SectionTitle = ({
  title,
  icon,
  creationLink,
  readOnly,
  right,
  isSending,
  t,
}) => (
  <TitleAndAction>
    <CardTitle style={{ marginBottom: 0, flex: 1 }}>
      {icon}
      {title}
    </CardTitle>
    {Boolean(creationLink) && !readOnly && (
      <div style={right && { position: 'absolute', right: 0 }}>
        <DesktopButton as={Link} to={creationLink} isPrimary>
          <MdAdd /> {t(`${isSending ? 'send' : 'new'}`)}
        </DesktopButton>

        <MobileButton as={Link} to={creationLink} isPrimary>
          <MdAdd />
        </MobileButton>
      </div>
    )}
  </TitleAndAction>
);

export default withTranslation('misc')(SectionTitle);
